import { Navbar,Destinations1,Footer } from "../components"

const Visitings = ()=>{
    return (
        <div>
            <Navbar />
            <Destinations1 />
            <Footer />
        </div>
        
    )
}

export default Visitings;